import { GoSearcherBusinessRoute, SearchPerseusConfig } from '@fiverr-private/listing_types';
import { validateQuery } from '../../util';
import { GigFlow } from './GigFlow';

export class GigBusinessSearchFlow extends GigFlow {
    timeout?: number;
    metricRouteKey: string;
    servicePath: string;

    route: GoSearcherBusinessRoute = 'fiverr_business/search';
    routeName = 'fiverr_business_search';
    validateRequest = validateQuery;

    constructor(serviceConfigs: SearchPerseusConfig) {
        super('gigBusinessSearchFlow', serviceConfigs);

        const { search_service: searchService } = serviceConfigs;
        const { timeout, name, url } = searchService;

        if (timeout?.[this.routeName]) {
            this.timeout = timeout[this.routeName];
        }

        this.metricRouteKey = `${name}.${this.routeName}`;
        this.servicePath = `${url}/v5/${this.route}`;
    }
}
